
<script setup lang="ts">
import { Icon } from '@iconify/vue/dist/iconify.js'

interface Props {
  // Button behavior
  loading?: boolean
  disabled?: boolean
  visible?: boolean
  type?: 'button' | 'submit' | 'reset'
  
  // Button content
  text?: string
  icon?: string
  iconSize?: string
  
  // Loading state
  loadingIcon?: string
  loadingIconSize?: string
  
  // Styling
  variant?: 'success' | 'primary' | 'danger' | 'warning' | 'secondary' | 'info'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  block?: boolean
  outlined?: boolean
  rounded?: boolean
  
  // Custom classes
  customClass?: string
  

}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  disabled: false,
  visible: true,
  type: 'button',
  text: 'Lưu chỉnh sửa',
  icon: 'ri:save-3-fill',
  iconSize: '16px',
  loadingIcon: 'eos-icons:three-dots-loading',
  loadingIconSize: '20px',
  variant: 'success',
  size: 'md',
  block: false,
  outlined: false,
  rounded: false,
  customClass: ''
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const handleClick = (event: MouseEvent) => {
  if (!props.loading && !props.disabled) {
    emit('click', event)
  }
}
</script>

<template>
  <button
    :class="['btn btn-cs outline flex items-center gap-3', disabled || loading ? 'btn-disabled' : '', 
              `btn-${variant}`, `btn-${size}`, 
              block ? 'btn-block' : '', 
              outlined ? 'btn-outlined' : '', 
              rounded ? 'btn-rounded' : '', 
              customClass]"
    :disabled="loading || disabled"
    @click="handleClick"
    v-if="visible"
    :type="type"
  >
    <!-- Icon bên trái -->
    <Icon 
      v-if="icon && !loading"
      :icon="icon" 
      :width="iconSize" 
      :height="iconSize" 
    />
    
    <!-- Loading icon -->
    <Icon 
      v-if="loading"
      :icon="loadingIcon" 
      :width="loadingIconSize" 
      :height="loadingIconSize" 
      class="animate-spin"
    />
    
    <!-- Text content -->
    <span v-if="$slots.default || text">
      <slot>{{ text }}</slot>
    </span>
  </button>
</template>
